import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import Condicional from '../../Layout/Condicional'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import { CampanhaInterface } from '../../ImportBackend/Interfaces/CampanhaInterfaces'
import ClsCrud, { StatusForm } from '../../Utils/ClsCrud'

import ClsValidacao from '../../Utils/ClsValidacao'
import { EMDESENVOLVIMENTO, URL_CLIENT } from '../../ImportBackend/Config/emDesenvolvimento'

interface PesquisaInterface {
  descricao: string
}

export default function Campanhas() {

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    },
    {
      campo: 'idCampanha',
      cabecalho: 'URL',
      alinhamento: 'left',
      format: (v) => URL_CLIENT.concat('AgendamentoAvaliacao/',v.toString())
    },
    {
      campo: 'ativa',
      cabecalho: 'Ativa',
      alinhamento: 'left',
      format: (v) => v ? 'Sim' : 'Não'
    }
  ]

  const ResetDados: CampanhaInterface = {
    idCampanha: 0,
    descricao: '',
    ativa: false
  }

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de Nova Campanha',
    [StatusForm.Excluindo]: 'Exclusão de Campanha Não Utilizada',
    [StatusForm.Pesquisando]: 'Campanhas disponívels no APP',
    [StatusForm.Editando]: 'Alteração de Dados de Campanhas',
  }

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [dados, setDados] = useState<CampanhaInterface>(ResetDados)

  const [erros, setErros] = useState({})

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ descricao: '' })

  const [rsPesquisa, setRsPesquisa] = useState<Array<CampanhaInterface>>([])

  const navigate = useNavigate()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('descricao', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const clsCrud: ClsCrud<CampanhaInterface> = new ClsCrud(
    navigate,
    ResetDados,
    setStatusForm as unknown as any,
    setDados,
    setErros,
    mensagemState,
    setMensagemState,
    setRsPesquisa,
    contexto,
    validarDados,
    {
      confirmarMutation: 'updateCampanha',
      excluirMutation: 'delCampanha',
      campoId: 'idCampanha',
      camposPesquisa: '{idCampanha ativa descricao}',
      pesquisaQuery: 'getCampanhas',
      pesquisaPorId: 'getCampanhaPorId',
      camposPesquisaPorId: '{idCampanha ativa descricao}'
    },
    {
      confirmando: 'Atualizando Campanha',
      erroCadastro: 'Erro ao Cadastrar Campanha',
      erroExclusao: 'Erro ao Excluir Campanha',
      erroPesquisa: 'Erro ao Pesquisar Campanha',
      pesquisando: 'Pesquisando Dados de Campanhas...',
      sucessoCadastro: 'Campanha Cadastrada com Sucesso!',
      atualizacaoSucesso: 'Campanha Atualizada com Sucesso!',
      tituloConfirmado: 'Confirmado!',
      sucessoExclusao: 'Campanha Excluída com Sucesso...',
      tituloConfirmacaoExclusao: 'Confirma?',
      tituloErroCadastro: 'Erro!',
      tituloErroExclusao: 'Erro!',
      tituloErroPesquisa: 'Erro!',
      excluindo: 'Excluindo Campanha...'
    }
  )


  const onKeyPesquisa = () => {
    clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Cadastro de Campanhas
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => clsCrud.btFechar()}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={10} >

                <InputText
                  dados={pesquisa}
                  field='descricao'
                  label='Pesquisar'
                  setState={setPesquisa}
                  iconeEnd="search"
                  onClickIconeEnd={() => clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)}
                  mapKeyPress={[{ key: 'Enter', onKey: onKeyPesquisa }]}
                />

              </Grid>

              <Grid item xs={12} sm={2} sx={{ mt: { xs: 3, sm: 4.5 }, textAlign: { xs: 'right', sm: 'center' } }}>
                <Button variant='contained' onClick={
                  () => {
                    clsCrud.btIncluir()
                  }
                }>Incluir</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Pesquisando}>

              <Grid item xs={12}>

                <InputText
                  dados={dados}
                  field='descricao'
                  label='Descrição'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={50}
                />

              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={dados}
                  field='ativa'
                  label='Ativa'
                  setState={setDados}
                  tipo='checkbox'
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>

                <Condicional condicao={statusForm === StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmarExclusao(dados, mensagemState, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmar(dados, mensagemState, statusForm as unknown as any, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Cancelar</Button>

              </Grid>

            </Condicional>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable dados={rsPesquisa} cabecalho={Cabecalho} acoes={[
                  { icone: 'delete', toolTip: 'Exluir', onAcionador: clsCrud.btExcluir },
                  { icone: 'create', toolTip: 'Editar', onAcionador: clsCrud.btEditar }]} />
              </Grid>
            </Condicional>

            <Condicional condicao={EMDESENVOLVIMENTO && false}>
              <Grid item xs={12}>
                <pre >
                  {JSON.stringify(dados, null, 4)}
                </pre>
              </Grid>
            </Condicional>

          </Grid>
        </Paper>

      </Container>
    </>
  )
}